<!-- Add/Edit News Letter Modal -->
<div class="modal fade" id="kt_modal_news_letter_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h2 class="fw-bold">{{ isEditMode ? 'Edit' : 'Add' }} News Letter</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body py-10 px-lg-17">
        <form [formGroup]="newsLetterForm" (ngSubmit)="onSubmit()">
          <div class="row mb-5">
            <!-- Model Multi-Select Search -->
            <div class="col-md-6 fv-row mb-5">
              <label class="fs-6 fw-semibold mb-2">Model</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" placeholder="Search models..."
                  [value]="modelSearchTerm" (input)="onModelSearchInput($event)" (focus)="onModelInputFocus()"
                  (blur)="onModelInputBlur()" />
                <div class="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                  style="max-height: 200px; overflow-y: auto; z-index: 1050;" *ngIf="showModelDropdown">
                  <div class="text-center py-2" *ngIf="isModelSearching">
                    <span class="spinner-border spinner-border-sm"></span> Searching...
                  </div>
                  <div class="p-2 cursor-pointer hover-bg-light" *ngFor="let model of modelSearchResults"
                    (mousedown)="selectModel(model)">
                    {{ model.name }}
                  </div>
                  <div class="text-muted p-2" *ngIf="!isModelSearching && modelSearchResults.length === 0">
                    No models found
                  </div>
                </div>
              </div>
              <!-- Selected Models Tags -->
              <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="selectedModels.length > 0">
                <span class="badge badge-light-primary d-flex align-items-center" *ngFor="let model of selectedModels">
                  {{ model.name }}
                  <i class="ki-duotone ki-cross fs-6 ms-2 cursor-pointer" (click)="removeModel(model)">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
              </div>
            </div>

            <!-- Make Multi-Select Search -->
            <div class="col-md-6 fv-row mb-5">
              <label class="fs-6 fw-semibold mb-2">Make</label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" placeholder="Search makes..."
                  [value]="makeSearchTerm" (input)="onMakeSearchInput($event)" (focus)="onMakeInputFocus()"
                  (blur)="onMakeInputBlur()" />
                <div class="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                  style="max-height: 200px; overflow-y: auto; z-index: 1050;" *ngIf="showMakeDropdown">
                  <div class="text-center py-2" *ngIf="isMakeSearching">
                    <span class="spinner-border spinner-border-sm"></span> Searching...
                  </div>
                  <div class="p-2 cursor-pointer hover-bg-light" *ngFor="let make of makeSearchResults"
                    (mousedown)="selectMake(make)">
                    {{ make.name }}
                  </div>
                  <div class="text-muted p-2" *ngIf="!isMakeSearching && makeSearchResults.length === 0">
                    No makes found
                  </div>
                </div>
              </div>
              <!-- Selected Makes Tags -->
              <div class="d-flex flex-wrap gap-2 mt-2" *ngIf="selectedMakes.length > 0">
                <span class="badge badge-light-primary d-flex align-items-center" *ngFor="let make of selectedMakes">
                  {{ make.name }}
                  <i class="ki-duotone ki-cross fs-6 ms-2 cursor-pointer" (click)="removeMake(make)">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </i>
                </span>
              </div>
            </div>
          </div>

          <!-- Country Multi-Select -->
          <div class="row mb-5">
            <div class="col-12 fv-row">
              <label class="fs-6 fw-semibold mb-2">Country</label>
              <div class="d-flex flex-wrap gap-4"
                style="max-height: 150px; overflow-y: auto; border: 1px solid #e4e6ef; border-radius: 0.475rem; padding: 10px;">
                <div class="form-check form-check-custom form-check-solid" *ngFor="let country of countriesList">
                  <input class="form-check-input" type="checkbox" [id]="'country_' + country.slug"
                    [checked]="isCountrySelected(country.code)" (change)="onCountryChange($event, country.code)" />
                  <label class="form-check-label" [for]="'country_' + country.slug">{{ country.name }}</label>
                </div>
              </div>
            </div>
          </div>

          <!-- News Letter Radio -->
          <div class="row mb-5">
            <div class="col-12 fv-row">
              <label class="fs-6 fw-semibold mb-2 required">News Letter</label>
              <div class="d-flex gap-5">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="radio" formControlName="news_letter" id="send_newsletter"
                    value="send_newsletter" />
                  <label class="form-check-label" for="send_newsletter">Send Newsletter</label>
                </div>
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="radio" formControlName="news_letter" id="save" value="save" />
                  <label class="form-check-label" for="save">Save</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Audience Checkboxes -->
          <div class="row mb-5">
            <div class="col-12 fv-row">
              <label class="fs-6 fw-semibold mb-2">Audience</label>
              <div class="d-flex gap-5">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" id="subscriber"
                    [checked]="isAudienceSelected('subscriber')" (change)="onAudienceChange($event, 'subscriber')" />
                  <label class="form-check-label" for="subscriber">Subscriber</label>
                </div>
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" id="member" [checked]="isAudienceSelected('member')"
                    (change)="onAudienceChange($event, 'member')" />
                  <label class="form-check-label" for="member">Member</label>
                </div>
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" id="inquiry" [checked]="isAudienceSelected('inquiry')"
                    (change)="onAudienceChange($event, 'inquiry')" />
                  <label class="form-check-label" for="inquiry">Inquiry</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Title -->
          <div class="row mb-5">
            <div class="col-12 fv-row">
              <label class="fs-6 fw-semibold mb-2 required">Title</label>
              <input type="text" class="form-control form-control-solid" formControlName="title"
                placeholder="Enter title" [ngClass]="{'is-invalid': title?.invalid && title?.touched}" />
              <div class="invalid-feedback" *ngIf="title?.invalid && title?.touched">
                <span *ngIf="title?.errors?.['required']">Title is required</span>
              </div>
            </div>
          </div>

          <!-- Description -->
          <div class="row mb-5">
            <div class="col-12 fv-row">
              <label class="fs-6 fw-semibold mb-2">Description</label>
              <textarea class="form-control form-control-solid" formControlName="description" rows="4"
                placeholder="Enter description"></textarea>
            </div>
          </div>
        </form>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer flex-center">
        <button type="button" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isLoading">
          <span *ngIf="!isLoading">{{ isEditMode ? 'Update' : 'Save' }}</span>
          <span *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Updating...' : 'Saving...' }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
